import React from 'react';
import LinkList from '../LinkList';
import { generateOpenUrl } from '../../utils/open-url';

export default function OpenUrlLinkList({ doc, urlResolvers }) {
  let openUrls;

  if (urlResolvers.items) { // link_resolver_api_method === 'legacy'
    openUrls = urlResolvers.items.map(resolver => ({
      name: resolver.name,
      url: generateOpenUrl({
        baseUrl: resolver.url,
        doc,
        author: 'mendeley.com/mendeley'
      })
    }));
  } else { // link_resolver_api_method === 'registered_institution_profiles'
    openUrls = urlResolvers.map(resolver => ({
      name: resolver.name,
      url: generateOpenUrl({
        baseUrl: resolver.baseUrl,
        doc,
        author: 'mendeley.com/mendeley'
      })
    }));
  }
  return <LinkList links={openUrls} />;
}



// WEBPACK FOOTER //
// ./src/universal/ui/components/FindThisPaper/OpenUrlLinkList.js